export class ServiceGridViewModel {
    constructor() {
        this.name = "";
        this.description = "";
    }
}
export default class Services extends ServiceGridViewModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
